import Vue from 'vue'
import Vuex from 'vuex'
import {getField, updateField} from 'vuex-map-fields'
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        drawer: false
    },
    getters:{
        getField
    },
    mutations:{
        updateField,
        SET_DRAWER(state, payload){
            state.drawer=payload
        }
    }
})